import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksExecutors(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		options
	)
}

function _getOrderGeneratorsFieldsWorksExecutor(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
		options
	)
}

function _createOrderGeneratorsFieldsWorksExecutor(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
		options
	)
}


function createOrderGeneratorsFieldsWorksExecutorBulk(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR_BULK,
		options
	)
}

function _putOrderGeneratorsFieldsWorksExecutor(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksExecutor(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksExecutor(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS]: _getOrderGeneratorsFieldsWorksExecutors,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: _getOrderGeneratorsFieldsWorksExecutor,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: _createOrderGeneratorsFieldsWorksExecutor,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR_BULK]: createOrderGeneratorsFieldsWorksExecutorBulk,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: _putOrderGeneratorsFieldsWorksExecutor,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: _patchOrderGeneratorsFieldsWorksExecutor,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR]: _deleteOrderGeneratorsFieldsWorksExecutor,
}